import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import * as AdminActions from '../../store/actions/adminActions';
import Boundary from '../Boundary.js';

class SubjectEngagement extends Component {
    componentDidMount(){
        this.init();
    }

    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.init();
        }
    }

    init = () => {
        // console.log("Initting");

        this.props.getData(this.props.match.params.courseId, 1, this.props.user.user.id, this.props.user.id);


    }

    
    render(){
        return (

            <div className="panel customPanel">
                <div className="panel-heading border-bottom panel-heading-with-subtext">
                    <h3 className="panel-title">Subject Engagement</h3>
                </div>
                <div className="panel-body no-padding">
                    <Boundary>
                        {!this.props.engagementChartsLoading['subjects'] ?
                            <div id="SubjectGraph" >

                                {this.props.engagementCharts['subjects'] ?
                                    <ReactHighmaps
                                        config={this.props.engagementCharts['subjects']}
                                        isPureConfig={true}
                                        neverReflow={true}
                                        ref="chartde344"
                                    />
                                    :
                                    null
                                }
                            </div>
                        : null
                        }
                    </Boundary>
                        
                </div>
                <div className="panel-footer">
                    <div className="w-200">
                        <div className="form-select-overlay ">
                            <select value={this.props.engagementChartsLength['subjects']} onChange={e => {
                                e.preventDefault();

                                this.props.getData(this.props.match.params.courseId, e.target.value, this.props.user.user.id, this.props.user.id);
                            }} className="form-control" required="required">
                                <option value={1}>Yesterday</option>
                                {/*
                                <option value={2}>2 day</option>
                                <option value={7}>1 Week</option>
                                <option value={30}>1 Month</option>
                                <option value={365}>1 Year</option>
                                */}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getData: (courseId, length, userId, token) => {
        dispatch(AdminActions.getEngagementChart('subjects', length, courseId, userId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SubjectEngagement));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/SubjectEngagement.js